import axios from "axios";
import { saveAs } from 'file-saver';
import { 
  GET_LICENSES_PURCHASES,
  GET_PURCHASES,
  CLEAR_PURCHASES,
  CHANGE_CRE_LICENSE_PURCHASES,
  SET_PURCHASES_FILTERS,
} from "redux/reducers/purchases/purchasesReducer";
import { START_REQUEST_SEARCH, STOP_REQUEST_SEARCH, SET_SNACKBAR_SEARCH } from "redux/reducers/search/searchReducer";
import { api_get } from "services/api";
import { setSnackbar } from "../search/searchActions";

export const getCRE_Licenses = () => {
  const url = `${process.env.REACT_APP_URL}/crm/stations/cre_licenses`
  let payload = {}
  return async( dispatch ) => {
    await api_get(url).then(resp => {
      payload = {
        type: GET_LICENSES_PURCHASES,
        payload: resp
      }
      dispatch(payload)
    }).catch(error => {
      dispatch(setSnackbar(error))
    })
  }
}

export const getPurchases = ( token, licence, start, end ) => {
  const paramsString = `?licence=${licence}&start=${start}&end=${end}`
  const options = {
    method: 'GET',
    url: `${process.env.REACT_APP_URL}/crm/shipments${paramsString}`,
    headers: { Authorization: token },
  }
  let payload = {}
  return async ( dispatch ) => {
    dispatch({ type: START_REQUEST_SEARCH })
    
    await axios.request(options).then(resp => {
      payload = {
        type: GET_PURCHASES,
        payload: resp.data
      }
      dispatch(payload)
    }).catch(error => {
      const err = error.response?.data?.message?.error
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: err ? err : "Error contacte con el administrador", color: 'danger' }
      })
    })
    dispatch({ type: STOP_REQUEST_SEARCH })
  }
}

export const downloadDoc =  (date, licence, token, fileType) => {
  const auth = { headers: { authorization: token } };
  const reportUrl = `${process.env.REACT_APP_URL}/crm/stations/sales/${fileType}?licence=${licence}&date=${date}`;
  const fileName = `Ventas_${licence}_${date}.${fileType}`
  return async (dispatch) => {
    dispatch({type: START_REQUEST_SEARCH})
    const access = {
      url: reportUrl,
      method: 'GET',
      responseType: 'blob',
      ...auth
    }
    await axios(access).then(resp => {
      saveAs(resp.data, fileName)
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: `${fileType.toUpperCase()} Descargado con éxito`, color: 'success' }
      })
    }).catch(err => {
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: err.message ? err.message : err, color: 'danger' }
      })
      return err
    })
    dispatch({type: STOP_REQUEST_SEARCH})
  }
}

export const setPurchasesFilters = ( name, value ) => {
  return {
    type: SET_PURCHASES_FILTERS,
    payload: { name, value },
  };
}

export const changeCreLicensePurchases = ( license ) => {
  return {
    type: CHANGE_CRE_LICENSE_PURCHASES,
    payload: license,
  };
}

export const clearPurchases = () => {
  return {
    type: CLEAR_PURCHASES,
  }
}

